import { payment } from 'apis';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export const useCardPaymentRqsts = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const handleAlphaBankRqst = async (data) => {
        const { transactionRelId, paidAmount, operator, description } = data;
        if (transactionRelId && paidAmount && operator && description) {
            const res = await payment.pay({
                TransHeaderId: transactionRelId,
                Total: paidAmount,
                Operator: operator,
                Description: description
            });
            if (res.status === 'success') {
                const data = JSON.parse(res.data);
                const form = document.getElementById('paymentForm_AlphaBank');
                document.getElementById('paymentForm_AlphaBank').action = data?.bankPostUrl;
                form.querySelector('#mid').value = data?.mid;
                form.querySelector('#lang').value = data?.lang;
                form.querySelector('#orderid').value = data?.orderid;
                form.querySelector('#orderAmount').value = data?.orderAmount;
                form.querySelector('#orderDesc').value = data?.orderDesc;
                form.querySelector('#currency').value = data?.currency;
                form.querySelector('#payerEmail').value = data?.payerEmail;
                form.querySelector('#payerPhone').value = data?.payerPhone;
                form.querySelector('#billCountry').value = data?.billCountry;
                form.querySelector('#billAddress').value = data?.billAddress;
                form.querySelector('#billCity').value = data?.billCity;
                form.querySelector('#billZip').value = data?.billZip;
                form.querySelector('#confirmUrl').value = data?.confirmUrl;
                form.querySelector('#cancelUrl').value = data?.cancelUrl;
                form.querySelector('#digest').value = data?.digest;
                document.getElementById('paymentForm_AlphaBank').submit();
            } else enqueueSnackbar(t('ErrorOccured'), { variant: 'error' });
        }
    };

    const handlePiraeusBankRqst = async (data) => {
        const { transactionRelId, paidAmount, operator } = data;
        if (transactionRelId && paidAmount && operator) {
            const res = await payment.pay({ TransHeaderId: transactionRelId, Total: paidAmount, Operator: operator });
            if (res.status === 'success') {
                const data = JSON.parse(res.data);
                const form = document.getElementById('paymentForm_Piraeus');
                document.getElementById('paymentForm_Piraeus').action = data?.PaymentUrl;
                form.querySelector('#AcquirerId').value = data?.AcquirerId;
                form.querySelector('#MerchantId').value = data?.MerchantId;
                form.querySelector('#PosId').value = data?.PosId;
                form.querySelector('#User').value = data?.User;
                form.querySelector('#MerchantReference').value = data?.MerchantReference;
                form.querySelector('#LanguageCode').value = data?.LanguageCode;
                form.querySelector('#BillAddrCity').value = data?.BillAddrCity;
                form.querySelector('#BillAddrCountry').value = data?.BillAddrCountry;
                form.querySelector('#BillAddrLine1').value = data?.BillAddrLine1;
                form.querySelector('#BillAddrPostCode').value = data?.BillAddrPostCode;
                form.querySelector('#Email').value = data?.Email;
                form.querySelector('#HomePhone').value = data?.HomePhone;
                document.getElementById('paymentForm_Piraeus').submit();
            } else enqueueSnackbar(t('ErrorOccured'), { variant: 'error' });
        }
    };

    const handleStripeRqst = async (data) => {
        const { transactionRelId, paidAmount, operator } = data;
        if (transactionRelId && paidAmount && operator) {
            const res = await payment.pay({ TransHeaderId: transactionRelId, Total: paidAmount, Operator: operator });
            if (res.status === 'success') {
                const data = res.data;
                window.location.href = data; // Redirect to Stripe payment page
            } else enqueueSnackbar(t('ErrorOccured'), { variant: 'error' });
        }
    };

    return { handleAlphaBankRqst, handlePiraeusBankRqst, handleStripeRqst };
};
